<template>
	<inertia-head title="SAM Table" />
	<div class="bg-primary">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">SAM Table</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Get the edge you need to become a successful long-term investor with SAM Table! Our comprehensive reference helps you make smarter decisions on what stocks to buy and when to buy them, without the guesswork and complexity. With our easy-to-use tool, you can quickly identify the best stocks and confidently invest for the future.
					</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content mt-5">
		
		<span class="float-end text-end m-3">
			<button @click="setStockReminderModal.toggleModal" type="button" class="btn btn-sm btn-info"><i class="fa fa-clock me-1"></i>Set a Reminder</button>
		</span>
		<div class="block block-rounded">
			<div class="block-content block-content-full">
				<div v-if="user.current_rank === 'SILVER'">
					<div class="alert alert-warning">
						<p class="mb-0 fw-semibold">
							UPGRADE to GOLD or HIGHER to view SAM TABLE.
						</p>
					</div>
				</div>
				<div v-else>
					<h4 class="content-heading fw-semibold fs-sm pt-1">
						Maximum Percentage:
						<small class="fs-sm">
							Distribute your money to various stocks. Don't put more than 10%
							or 20% of your total money in each stock.
						</small>
					</h4>
					<div>
						<p class="fw-semibold mb-2">Last Updated: {{stocks.data.length>0?stocks.data[0].lasttradedate:''}}</p>
						<p class="fs-sm">The SAM table is updated every 30 minutes when the market is open.</p>
					</div>
					<!-- horizontal filters -->
					<div class="row">
						<div class="col-md-8">
							<div class="row mb-4">
								<label class="col-sm-1 col-form-label fs-sm">Show</label>
								<div class="col-sm-2">
									<select
										v-model="per_page"
										class="form-control form-control-sm"
									>
										<option
											v-for="per_page in [25, 50, 100]"
											:key="per_page"
											:value="per_page"
										>
											{{ per_page }}
										</option>
									</select>
								</div>
							</div>
						</div>
						<div class="col-md-4">
							<div class="row mb-4">
								<label class="col-sm-3 col-form-label fs-sm">Search</label>
								<div class="col-sm-9">
									<input
										v-model="query"
										type="search"
										class="form-control fs-sm form-control-sm"
										placeholder="Search stock here..."
									/>
								</div>
							</div>
						</div>
					</div>
					<div class="table-responsive">
						<table class="table table-striped table-borderless table-hover table-vcenter">
							<thead class="fs-sm">
								<tr>
									<th>#</th>
									<th>Stocks</th>
									<th>Current Price</th>
									<th>Buy Below Price</th>
									<th>Target Price</th>
									<th>Expected Growth</th>
									<th>Max%</th>
									<th>% From Target Price</th>
									<th>Recommendation</th>
								</tr>
							</thead>
							<tbody class="fs-sm">
								<tr v-for="(stock, index) in stocks.data" :key="stock.stock">
									<td>{{ index + stocks.from }}</td>
									<td class="fw-semibold">
										<InertiaLink href="" class="text-success">
											{{ stock.stock }}
										</InertiaLink>
									</td>
									<td>{{ stock.tradeprice }}</td>
									<td>{{ stock.buybelowprice }}</td>
									<td>{{ stock.targetprice }}</td>
									<td>{{ stock.expected_growth }}%</td>
									<td>{{ stock.maxperc }}%</td>
									<td>{{ stock.target_perc }}%</td>
									<td class="fw-semibold"
										:class="
											stock.actiontotake === 'Continue Buying'
												? 'text-success'
												: stock.actiontotake === 'Stop Buying'
												? 'text-danger'
												: stock.actiontotake === 'Hold'
												? 'text-warning'
												: stock.actiontotake === 'Sell'
												? 'text-info'
												: 'text-secondary'
										"
									>
										<small>{{ stock.actiontotake }}</small>
									</td>
								</tr>
								<tr v-if="stocks.data.length == 0">
									<td colspan="9">
										<p class="m-2 fw-semibold text-center text-danger">NO RECORD FOUND</p>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<pagination :collections="stocks" />
				</div>
			</div>
		</div>

		<set-stock-reminder-modal
		ref="setStockReminderModal"
		:stockReminders="stockReminders"
		:rank-prefix="rank_prefix"
		@changeAction="changeAction"
		></set-stock-reminder-modal>


	</div>
</template>

<script>
import debounce from 'lodash/debounce'
import { onMounted, ref, watch } from 'vue'
import { Inertia } from '@inertiajs/inertia'
import AuthLayout from '../../../../Layouts/AuthLayout'
import SetStockReminderModal from '../../../../Components/Member/SetStockReminderModal'
import { createToaster } from '@meforma/vue-toaster';

export default {
	layout: AuthLayout,
	props: {
		user			: Object,
		rank_prefix 	: String,
		stocks 			: Object,
		stockReminders 	: Object,
		filters 		: Object,
		errors 			: Object,
		api_response 	: Object
	},
	components:{SetStockReminderModal},
	setup(props) {
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')
		})

		const toast = createToaster();

		const action 				= ref('add');
		const query 				= ref(props.filters.query);

		const setStockReminderModal = ref(null);

		const per_page = ref(props.filters.per_page ?? 25);

		const changeAction =(value)=>{
			action.value = value;
		}

		watch(
			query,
			function (value) {
				var param = { per_page : per_page.value };

				if(value!='')
				{
					param.query = value;
				}

				Inertia.get(
					'/member/my-materials/sam-table',
					param,
					{
						// replace: true,
						preserveState: true,
						preserveScroll: true,
						only: ['stocks', 'filters']
					}
				)
			}
		)

		watch(per_page, (value) => {
			var param = { per_page : value };

			if(query.value!='')
			{
				param.query = query.value;
			}

			Inertia.get(
				'/member/my-materials/sam-table', param,
				{
					// replace: true,
					preserveState: true,
					preserveScroll: true,
					only: ['stocks', 'filters']
				}
			)
		})

		watch(()=>props.api_response, (value) => {
			
			if(value!=null)
			{
				var action_msg = action.value=='update' ? 'updated' : (action.value=='delete' ? 'deleted' : 'added');

				if(value.result=="success")
				{
					toast.show("Successfully "+action_msg, { type: value.result});
				}else if(value.result=="exceed")
				{
					toast.show(value.data, { type: "error"});
				}else
				{
					toast.show("Failed to "+action_msg, { type: "error"});
				}
			}
		})

		return {
			action,
			changeAction,
			query,
			per_page,
			setStockReminderModal
		}
	},
}
</script>
